<template>
    <div class="render-post hide-scrollbar render-post-youtube" :style="{ fontSize: fontSize + 'px' }" ref="render-post">

        <template v-if="medias.length && medias.find(m => m.info.type2 == 'video')">
            <div v-for="media in medias.filter(m => m.info.type.startsWith('video/')).slice(0,1)" class="post-medias media" :key="media.id">
                <div class="media">
                    <video :autoplay="autoplayVideo" muted loop playsinline preload="metadata" :src="media.url" :type="media.info.type" onloadedmetadata="this.muted = true"></video>
                </div>
            </div>
        </template>
       
        <div class="post-empty" v-else>
        </div>
        <div class="post-content hide-scrollbar">
            <div class="post-title" >
                <p v-if="title" v-html="titleTranslateMentionAndHastag"></p>
                <p v-else>Unknown</p>
            </div>
            <div class="post-date">
                <p>{{ datePost ? formatDatePost : 'A l\'instant' }}</p>
            </div>

            <div class="post-author">
                <div class="img-pages">

                    <template v-for="(page, index) in pages.slice(0,pages.length == 4 ? 4 : 3)">
                        <Tooltip 
                            :active="page.iconEdited" 
                            :text="'Voir les modifications apportées'" 
                            position="right" 
                            :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`" 
                            @click="()=>{page.iconEdited ? $emit('clickPage', page.id) : openYoutubePage(page)}" 
                            :key="index"
                        >
                            <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                        </Tooltip>
                    </template>

                    <div class="page count" v-if="pages.length > 4">
                        +{{ pages.length - 3 }}
                    </div>
                </div>
                <p class="name" v-if="pages.length <= 1" @click="openYoutubePage(pages[0])">{{ pages[0].name }}</p>
                
            </div>

            <div class="bar-action">
                <div class="like">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" focusable="false" style="pointer-events: none; display: inherit; width: 100%; height: 100%; transform: rotate(180deg);">
                        <path d="M17,4h-1H6.57C5.5,4,4.59,4.67,4.38,5.61l-1.34,6C2.77,12.85,3.82,14,5.23,14h4.23l-1.52,4.94C7.62,19.97,8.46,21,9.62,21 c0.58,0,1.14-0.24,1.52-0.65L17,14h4V4H17z M10.4,19.67C10.21,19.88,9.92,20,9.62,20c-0.26,0-0.5-0.11-0.63-0.3 c-0.07-0.1-0.15-0.26-0.09-0.47l1.52-4.94l0.4-1.29H9.46H5.23c-0.41,0-0.8-0.17-1.03-0.46c-0.12-0.15-0.25-0.4-0.18-0.72l1.34-6 C5.46,5.35,5.97,5,6.57,5H16v8.61L10.4,19.67z M20,13h-3V5h3V13z"></path>
                    </svg>
                    <div class="bar"></div>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" focusable="false" style="pointer-events: none; display: inherit; width: 100%; height: 100%;">
                        <path d="M17,4h-1H6.57C5.5,4,4.59,4.67,4.38,5.61l-1.34,6C2.77,12.85,3.82,14,5.23,14h4.23l-1.52,4.94C7.62,19.97,8.46,21,9.62,21 c0.58,0,1.14-0.24,1.52-0.65L17,14h4V4H17z M10.4,19.67C10.21,19.88,9.92,20,9.62,20c-0.26,0-0.5-0.11-0.63-0.3 c-0.07-0.1-0.15-0.26-0.09-0.47l1.52-4.94l0.4-1.29H9.46H5.23c-0.41,0-0.8-0.17-1.03-0.46c-0.12-0.15-0.25-0.4-0.18-0.72l1.34-6 C5.46,5.35,5.97,5,6.57,5H16v8.61L10.4,19.67z M20,13h-3V5h3V13z"></path>
                    </svg>
                </div>
                <div class="share">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" focusable="false" style="pointer-events: none; display: inherit; width: 100%; height: 100%;"><path d="M15 5.63 20.66 12 15 18.37V14h-1c-3.96 0-7.14 1-9.75 3.09 1.84-4.07 5.11-6.4 9.89-7.1l.86-.13V5.63M14 3v6C6.22 10.13 3.11 15.33 2 21c2.78-3.97 6.44-6 12-6v6l8-9-8-9z"></path></svg>
                    <p>Partager</p>
                </div>
            </div>
            <div class="description">
                <p v-html="textTranslateMentionAndHastag"></p>
            </div>

            <div class="comments" v-for="comment in comments">
                <h5>Commentaires</h5>
                <div class="comment">
                    <img :src="!pages || !pages.length || pages.length > 1 || !pages[0] ?  'img/avatar.jpg' : pages[0].avatar" alt="">
                    <p v-html="comment"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from './../SnippetNetwork.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[] 
            },
 
            title : {
                type: String,
                default: ''
            },
            text : {
                type: String,
                default: ''
            },
            comments : {
                type: Array,
                default: ()=>[]
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },

            mentions: {
                type: Object,
                default: ()=>({})
            },

           
        
           
        },

        methods: {
            openYoutubePage(page) {
                const url = `https://youtube.com/${page.name}/`;
                window.open(url, '_blank');
            }
        },

        computed: {
            autoplayVideo() {
                return !localStorage.screenshot
            },

            formatDatePost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            titleTranslateMentionAndHastag() {
                //return this.text
                return this.title.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.youtube ? `<span class="mention">@${mention.mention.youtube.id || mention.mention.youtube.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.youtube ? `<span class="mention">@${mention.mention.youtube.id || mention.mention.youtube.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            }
        },
    }
</script>
